module.exports = __webpack_public_path__ + "static/media/voicegen.adc0c20f.png";